import { useEffect, useState } from "react";

/** Sant när sidan körs inne i native-wrappern (aldrig under SSR). */
export function useIsAppMode(): boolean {
  const [appMode, setAppMode] = useState(false);
  useEffect(() => {
    let alive = true;
    void import("@/app-bridge/core/wrapper").then((m) => {
      if (alive) setAppMode(m.isAppMode());
    });
    return () => {
      alive = false;
    };
  }, []);
  return appMode;
}
